import { Loader2 } from 'lucide-react';

// Shown instead of a catalog page while a Quality Task deep link opens its single simulation
export const AssignedOpening = ({ failed, label }) => (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-3 text-center" data-testid="assigned-opening">
        {failed ? (
            <p className="max-w-sm text-sm text-muted-foreground" data-testid="assigned-opening-failed">
                We couldn&apos;t open this {label}. Please try again from Quality Tasks.
            </p>
        ) : (
            <>
                <Loader2 className="h-10 w-10 animate-spin text-violet-500" />
                <p className="text-sm text-muted-foreground">Opening your assigned {label}…</p>
            </>
        )}
    </div>
);
